import { formats } from '../../common/format';
import { getStore } from '@/store';

var monthConfig = (monthSimpleNames) => {
    let rt = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    };
    if (monthSimpleNames instanceof Array) {
        rt = {};
        monthSimpleNames.forEach((value, index) => {
            rt[('0' + (index + 1)).substr(-2)] = value;
        });
    }
    return rt;
};
const priceOptions = () => ({
    average: window.siteGlobalization.$t(
        'md-market-trends:md-market-trends.averageSoldPrice'
    ),
    median: window.siteGlobalization.$t(
        'md-market-trends:md-market-trends.medianSoldPrice'
    ),
    highest: window.siteGlobalization.$t(
        'md-market-trends:md-market-trends.highestSoldPrice'
    ),
    lowest: window.siteGlobalization.$t(
        'md-market-trends:md-market-trends.lowestSoldPrice'
    )
});
const option = (monthConfig, currencySymbol) => ({
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: 'rgba(145, 152, 161, 0.5)',
                type: 'dashed'
            }
        },
        padding: [0, 0, 0, 0],
        backgroundColor: 'rgba(32, 36, 55, 0.95)',
        position: function(point, params, dom, rect, size) {
            return [
                point[0] - dom.offsetWidth / 2,
                point[1] - dom.offsetHeight - 25
            ];
        },
        formatter: function(param) {
            var bar = param[0],
                line = param[1];
            var str = `
                <div class="chart-tooltip standard">
                    <div class="month">
                        ${monthConfig[param[0].name.replace(/.*?-/, '')]}
                    </div>
                    <div class="label price">
                        <span class="series-name"></span>
                        <span class="series-value">${formats.currency({
                value: line.value[line.seriesName],
                noSpace: true,
                units: true,
                currencySymbol,
            })
                }</span>
                    </div>
                    <div class="label count">
                    <span class="series-name"></span>
                    <span class="series-value">${bar.value[bar.seriesName]
                }</span>
                    </div>
                </div>
            `;

            return str;
        }
    },
    dataset: {
        dimensions: getDimensions(),
        source: []
    },
    xAxis: {
        type: 'category',
        boundaryGap: [15, 15],
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            margin: 15,
            color: '#a0a3af',
            interval: 0,
            formatter: function(value, index) {
                return monthConfig[value.replace(/.*?-/, '')];
            },
            fontFamily: 'font-normal',
            fontSize: 12
        }
    },
    yAxis: [
        {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#a0a3af',
                formatter: function(value) {
                    if (value === 0) {
                        return '0';
                    } else {
                        return formats.currency({ value, noSpace: true, units: true, currencySymbol });
                    }
                },
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            },
            splitLine: {
                show: false
            },
            offset: 0,
            splitArea: {
                show: true,
                areaStyle: {
                    color: ['#fafafd', '#ffffff']
                },
                interval: 1
            },
            splitNumber: 5
        },
        {
            type: 'value',
            scale: true,
            splitNumber: 5,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                color: '#a0a3af',
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            }
        }
    ],
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
        {
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
                color: '#29dea2',
                borderColor: '#29dea2',
                barBorderRadius: [2, 2, 0, 0]
            },
            barWidth: 12
        },
        {
            type: 'line',
            showSymbol: false,
            symbolSize: 2,
            lineStyle: {
                color: '#03c9ff',
                width: 4
            },
            itemStyle: {
                color: '#03c9ff',
                borderColor: '#03c9ff',
                borderWidth: 3
            }
        }
    ],
    backgroundColor: '#fff',
    grid: {
        containLabel: true,
        left: 0,
        right: 0,
        top: 5,
        bottom: 0
    }
});

const layout1option = (monthConfig, priceOptions, currencySymbol, { theme, lineColor, columnColor, text, tip, bgColor, isMobile }) => ({ // title means 'Primary Color', text means 'Text Color', tip means 'Tip Color'
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: 'rgba(145, 152, 161, 0.5)',
                type: 'dashed'
            }
        },
        padding: [0, 0, 0, 0],
        backgroundColor: 'rgba(32, 36, 55, 0.95)',
        position: function(point, params, dom, rect, size) {
            return [
                point[0] - dom.offsetWidth / 2,
                point[1] - dom.offsetHeight - 25
            ];
        },
        formatter: function(param) {
            var bar = param[0],
                line = param[1];
            var str = `
                <div class="chart-tooltip ${theme}">
                    <div class="month">
                        ${monthConfig[param[0].name.replace(/.*?-/, '')]}
                    </div>
                    <div class="label price">
                        <span class="series-name">${priceOptions[line.seriesName]
                        }: </span>
                        <span class="series-value">${formats.currency({
                            value: line.value[line.seriesName],
                            noSpace: true,
                            units: true,
                            currencySymbol,
                        })
                }</span>
                    </div>
                    <div class="label count">
                    <span class="series-name">${window.siteGlobalization.$t(
                    'md-market-trends:md-market-trends.soldNumber'
                )}: </span>
                    <span class="series-value">${bar.value[bar.seriesName]
                }</span>
                    </div>
                </div>
            `;

            return str;
        }
    },
    dataset: {
        dimensions: getDimensions(),
        source: []
    },
    xAxis: {
        type: 'category',
        boundaryGap: [15, 15],
        axisLine: {
            show: true,
            lineStyle: {
                color: '#dadada80'
            }
        },
        axisTick: {
            show: true
        },
        axisLabel: {
            margin: 15,
            color: text,
            interval: 0,
            formatter: function(value, index) {
                return monthConfig[value.replace(/.*?-/, '')];
            },
            fontFamily: 'font-normal',
            fontSize: 12
        }
    },
    yAxis: [
        {
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dadada80'
                }
            },
            axisTick: {
                show: true
            },
            axisLabel: {
                color: tip,
                formatter: function(value) {
                    if (value === 0) {
                        return '0';
                    } else {
                        return formats.currency({ value, noSpace: true, units: true, currencySymbol });
                    }
                },
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            },
            splitLine: {
                show: false
            },
            offset: 0,
            splitArea: {
                show: false,
            },
            splitNumber: 5
        },
        {
            type: 'value',
            scale: true,
            splitNumber: 5,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dadada80'
                }
            },
            axisTick: {
                show: true
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                color: tip,
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            }
        }
    ],
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
        {
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
                color: columnColor,
                borderColor: columnColor,
                barBorderRadius: [2, 2, 0, 0]
            },
            barWidth: isMobile ? 15 : 30
        },
        {
            type: 'line',
            showSymbol: false,
            symbolSize: 2,
            lineStyle: {
                color: lineColor,
                width: 2
            },
            itemStyle: {
                color: lineColor,
                borderColor: lineColor,
                borderWidth: 2
            }
        }
    ],
    backgroundColor: bgColor || '#fff',
    grid: {
        containLabel: true,
        left: 0,
        right: 0,
        top: 5,
        bottom: 0
    }
});
const fashionOption = (monthConfig, priceOptions, currencySymbol) => ({
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: 'rgba(145, 152, 161, 0.5)',
                type: 'dashed'
            }
        },
        padding: [0, 0, 0, 0],
        backgroundColor: 'rgba(32, 36, 55, 0.95)',
        position: function(point, params, dom, rect, size) {
            return [
                point[0] - dom.offsetWidth / 2,
                point[1] - dom.offsetHeight - 25
            ];
        },
        formatter: function(param) {
            var bar = param[0],
                line = param[1];
            var str = `
                      <div class="chart-tooltip fashion">
                          <div class="month">
                              ${monthConfig[param[0].name.replace(/.*?-/, '')]}
                          </div>
                          <div class="label price">
                              <span class="series-name">${priceOptions[line.seriesName]
                }: </span>
                              <span class="series-value">${formats.currency({
                    value: line.value[line.seriesName],
                    noSpace: true,
                    units: true,
                    currencySymbol
                })
                }</span>
                          </div>
                          <div class="label count">
                          <span class="series-name">${window.siteGlobalization.$t(
                    'md-market-trends:md-market-trends.soldNumber'
                )}: </span>
                          <span class="series-value">${bar.value[bar.seriesName]
                }</span>
                          </div>
                      </div>
                  `;

            return str;
        }
    },
    dataset: {
        dimensions: getDimensions(),
        source: []
    },
    xAxis: {
        type: 'category',
        axisLine: {
            show: true,
            lineStyle: {
                color: '#f1f2f3',
                width: 2
            }
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            margin: 22,
            color: '#8b93a7',
            interval: 0,
            fontFamily: 'font-normal',
            formatter: function(value, index) {
                return monthConfig[value.replace(/.*?-/, '')];
            }
        }
    },
    yAxis: [
        {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#8b93a7',
                formatter: function(value) {
                    if (value === 0) {
                        return '0';
                    } else {
                        return formats.currency({ value, noSpace: true, units: true, currencySymbol });
                    }
                },
                fontFamily: 'font-normal',
                margin: 20
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#f1f2f3',
                    width: 2
                }
            },
            offset: 0,
            splitNumber: 5
        },
        {
            type: 'value',
            scale: true,
            splitNumber: 5,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                color: '#8b93a7',
                fontFamily: 'font-normal',
                margin: 20
            }
        }
    ],
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
        {
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
                color: '#bfc5d1',
                borderColor: '#bfc5d1',
                barBorderRadius: [2, 2, 0, 0]
            },
            barWidth: 12
        },
        {
            type: 'line',
            showSymbol: true,
            symbolSize: 9,
            lineStyle: {
                color: '#4c84ff',
                width: 3
            },
            itemStyle: {
                color: '#4c84ff',
                borderColor: '#4c84ff',
                borderWidth: 3
            }
        }
    ],
    backgroundColor: '#fff',
    grid: {
        containLabel: true,
        left: 0,
        right: 0,
        top: 5,
        bottom: 0
    }
});
const classicOption = (monthConfig, priceOptions, currencySymbol) => ({
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: '#e0e0e0',
                type: 'solid'
            }
        },
        padding: [0, 0, 0, 0],
        backgroundColor: '#ffffff',
        position: function(point, params, dom, rect, size) {
            return [point[0], point[1] - dom.offsetHeight - 35];
        },
        formatter: function(param) {
            var bar = param[0],
                line = param[1];
            var str = `
                    <div class="chart-tooltip classic">
                        <div class="month">
                            ${monthConfig[param[0].name.replace(/.*?-/, '')]}
                        </div>
                        <div class="label price">
                            <span class="series-name">${priceOptions[line.seriesName]
                }: </span>
                            <span class="series-value">${formats.currency({
                    value: line.value[line.seriesName],
                    noSpace: true,
                    units: true,
                    currencySymbol
                })}</span>
                        </div>
                        <div class="label count">
                        <span class="series-name">${window.siteGlobalization.$t(
                    'md-market-trends:md-market-trends.soldNumber'
                )}: </span>
                        <span class="series-value">${bar.value[bar.seriesName]
                }</span>
                        </div>
                    </div>
                `;

            return str;
        }
    },
    dataset: {
        dimensions: getDimensions(),
        source: []
    },
    xAxis: {
        type: 'category',
        axisLine: {
            show: true,
            lineStyle: {
                color: '#e0e0e0',
                width: 1,
                type: 'dashed'
            }
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            margin: 15,
            color: '#a0a0a0',
            interval: 0,
            formatter: function(value, index) {
                return monthConfig[value.replace(/.*?-/, '')];
            },
            fontSize: 14,
            fontFamily: 'font-normal'
        }
    },
    yAxis: [
        {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#a0a0a0',
                formatter: function(value) {
                    if (value === 0) {
                        return '0';
                    } else {
                        return formats.currency({ value, noSpace: true, units: true, currencySymbol });
                    }
                },
                fontFamily: 'font-normal',
                margin: 20
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#e0e0e0',
                    width: 1,
                    type: 'dashed'
                }
            },
            offset: 0,
            splitNumber: 5
        },
        {
            type: 'value',
            scale: true,
            splitNumber: 5,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                color: '#a0a0a0',
                fontFamily: 'font-normal',
                margin: 20
            }
        }
    ],
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
        {
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
                color: '#1a88ff',
                borderColor: '#1a88ff',
                barBorderRadius: [2, 2, 0, 0]
            },
            barWidth: 12
        },
        {
            type: 'line',
            showSymbol: false,
            hoverAnimation: false,
            symbol: 'none',
            lineStyle: {
                color: '#4c84ff',
                width: 0
            },
            itemStyle: {
                color: '#4c84ff',
                borderColor: '#4c84ff',
                borderWidth: 3
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: 'rgba(26, 136, 255, 0.5)' // 0%  color at 
                        },
                        {
                            offset: 1,
                            color: 'rgba(26, 136, 255, 0)' // 100%  color at 
                        }
                    ],
                    global: false //  default is  false
                }
            }
        }
    ],
    backgroundColor: '#fff',
    grid: {
        containLabel: true,
        left: 0,
        right: 0,
        top: 5,
        bottom: 0
    }
});
const brokerOption = (monthConfig, priceOptions, currencySymbol) => ({
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: 'rgba(145, 152, 161, 0.5)',
                type: 'dashed'
            }
        },
        padding: [0, 0, 0, 0],
        backgroundColor: '#fff',
        position: function(point, params, dom, rect, size) {
            return [point[0], point[1] - dom.offsetHeight - 35];
        },
        formatter: function(param) {
            var bar = param[0],
                line = param[1];
            var str = `
                <div class="chart-tooltip broker">
                    <div class="month">
                        ${monthConfig[param[0].name.replace(/.*?-/, '')]}
                    </div>
                    <div class="label price">
                        <span class="series-name">${priceOptions[line.seriesName]
                }</span>
                        <span class="series-value">${formats.currency({
                    value: line.value[line.seriesName],
                    noSpace: true,
                    units: true,
                    currencySymbol
                })}</span>
                    </div>
                    <div class="label count">
                    <span class="series-name">${window.siteGlobalization.$t(
                    'md-market-trends:md-market-trends.soldNumber'
                )}</span>
                    <span class="series-value">${bar.value[bar.seriesName]
                }</span>
                    </div>
                </div>
            `;

            return str;
        }
    },
    dataset: {
        dimensions: getDimensions(),
        source: []
    },
    xAxis: {
        type: 'category',
        boundaryGap: [15, 15],
        axisLine: {
            show: true,
            lineStyle: {
                type: 'dashed',
                color: '#a8a8a8'
            }
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            margin: 15,
            color: '#a8a8a8',
            interval: 0,
            formatter: function(value, index) {
                return monthConfig[value.replace(/.*?-/, '')];
            },
            fontFamily: 'font-normal',
            fontSize: 12
        }
    },
    yAxis: [
        {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#a8a8a8',
                formatter: function(value) {
                    if (value === 0) {
                        return '0';
                    } else {
                        return formats.currency({ value, noSpace: true, units: true, currencySymbol });
                    }
                },
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            },
            splitLine: {
                show: true,
                lineStyle: {
                    type: 'dashed',
                    color: '#e0e0e0'
                }
            },
            offset: 0,
            splitArea: {
                show: false,
                interval: 1
            },
            splitNumber: 5
        },
        {
            type: 'value',
            scale: true,
            splitNumber: 5,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                color: '#a8a8a8',
                margin: 20,
                fontFamily: 'font-normal',
                fontSize: 12
            }
        }
    ],
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
        {
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
                color: '#ff781d',
                borderColor: '#ff781d',
                barBorderRadius: [2, 2, 0, 0]
            },
            barWidth: 6
        },
        {
            type: 'line',
            showSymbol: false,
            symbolSize: 2,
            lineStyle: {
                color: '#17b124',
                width: 2
            },
            itemStyle: {
                color: '#17b124',
                borderColor: '#17b124',
                borderWidth: 3
            }
        }
    ],
    backgroundColor: '#fff',
    grid: {
        containLabel: true,
        left: 0,
        right: 0,
        top: 5,
        bottom: 0
    }
});
const getOption = function(theme, isMobile, data, lineValue, currencySymbol, { lineColor, columnColor, title, text, tip, bgColor }) { // title means 'Primary Color', text means 'Text Color', tip means 'Tip Color'
    let result = {};
    let { monthSimpleNames } = getStore.call(this, 'page');
    let mConfig = monthConfig(monthSimpleNames);
    switch (theme) {
    case 'layout1':
        result = layout1option(mConfig, priceOptions(), currencySymbol, { theme, lineColor, columnColor, title, text, tip, bgColor, isMobile }); // title means 'Primary Color', text means 'Text Color', tip means 'Tip Color'
        break;
    case 'standard':
        result = option(mConfig, currencySymbol);
        break;
    case 'fashion':
        result = fashionOption(mConfig, priceOptions(), currencySymbol);
        break;
    case 'classic':
        result = classicOption(mConfig, priceOptions(), currencySymbol);
        break;
    case 'broker':
        result = brokerOption(mConfig, priceOptions(), currencySymbol);
        break;
    default:
        result = option(mConfig, currencySymbol);
    }
    if (isMobile) {
        //  The distance between the tick label and the axis 
        result.yAxis.forEach(axis => {
            axis.axisLabel.margin = 6;
        });
        // tooltip in the center 
        result.tooltip.position = function(point, params, dom, rect, size) {
            return [
                size.viewSize[0] / 2 - size.contentSize[0] / 2,
                size.viewSize[1] / 2 - size.contentSize[1] / 2
            ];
        };
        //  Support scrolling inside the table 
        result.dataZoom = [
            {
                type: 'inside',
                zoomLock: true,
                start: 50,
                end: 100
            },
            {
                type: 'slider',
                show: false,
                zoomLock: false,
                start: 0,
                end: 50
            }
        ];
    }
    result.dataset.dimensions = getDimensions(lineValue);
    result.dataset.source = data;
    let isValidData = data instanceof Array; // deal with ：data  is empty or {} An error will be reported here 
    let barData = isValidData ? data.map(item => item.count) : [];
    let lineData = isValidData ? data.map(item => item[lineValue]) : [];
    setYxisInterval(result, barData, lineData);
    return result;
};
const getMaxValue = value => {
    return Math.ceil(value / 9.5) * 10;
};
const getMinValue = value => {
    return Math.floor(value / 12) * 10;
};
//  Set the division interval of two vertical coordinates 
export const setYxisInterval = (option, barData = [], lineData = []) => {
    let [yxis1, yxis2] = option.yAxis;
    yxis2.max = getMaxValue(Math.max(...barData));
    yxis2.min = getMinValue(Math.min(...barData));
    yxis2.interval = (yxis2.max - yxis2.min) / 5;
    yxis1.max = getMaxValue(Math.max(...lineData));
    yxis1.min = getMinValue(Math.min(...lineData));
    yxis1.interval = (yxis1.max - yxis1.min) / 5;
    return option;
};


export const getDimensions = (lineValue = 'average') => {
    return  ['month', 'count', lineValue]
}

export default getOption;
